import { WorkflowsRoutePath } from "#src/routes/workflows";
import { RoutePath } from "#src/utils/route";

export const WorkflowCategoriesRoutePath = WorkflowsRoutePath.concat(
  new RoutePath({
    path: "/categories",
    title: "Workflow Categories",
  })
);
